<template>
  <div id="app" class="app-shell default_bg">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>
